const _sm = "640px"
const _md = "768px"
const _lg = "1024px"
const _xl = "1280px"
const _2xl = "1536px"
const config = { "sm": _sm, "md": _md, "lg": _lg, "xl": _xl, "2xl": _2xl,  }
export { config as default, _sm, _md, _lg, _xl, _2xl }